import * as STD                    from '@emersya/mpa-std-lib';
import EngineModule                from '../../../EngineModule';
import { NS as StandingCounterNS } from '../../../components/customers/standing/StandingCounter/StandingCounter';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'standing-counter',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	modulesBefore :    [
		'product-editor',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor',
		'viewer-planner-floor-editor',
		'viewer-planner-walls-editor',
		'standing-highSign',
		'standing-partitionsHeads'
	],
	modulesAfter :     [
		'standing-banner',
		'viewer-planner-furniture-editor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	usableCondition :  {
		type : 'and',
		LHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  'TARGET.basket.currentProduct',
			value :     null
		},
		RHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
			value :     null
		}
	},
	displayCondition : null,
	generateComponentConfiguration() : StandingCounterNS.Configuration {
		if (!this.translations.text || !this.translations.textColorMenu || !this.translations.textGraphic) {
			throw STD.errors.user('');
		}
		return {
			text :                 this.translations.text,
			textColorMenu :        this.translations.textColorMenu,
			forceBackgroundColor : this.configuration.forceBackgroundColor ? this.configuration.forceBackgroundColor : null,
			textGraphic :          this.translations.textGraphic
		};
	},
	async initialize() {
	}
});
